import { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";

const UserRoute = () => {
  const link = "https://api.dashboard.bhumu.com";
  // const link = "http://localhost:7051";
  // const link = "http://192.168.1.4:7051";

  const [userVerified, setUserVerified] = useState(false);
  const [role, setRole] = useState(null);
  const [dataAccessDays, setDataAccessDays] = useState(null);
  const [companyAccess, setCompanyAccess] = useState(null);

  const navigate = useNavigate();

  const verifyUser = async () => {
    try {
      const response = await fetch(`${link}/admin/verify`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-type": "application/json",
        },
      });

      if (response.ok) {
        const respData = await response.json();
        setRole(respData.user.role);
        setDataAccessDays(respData.user.days);
        setCompanyAccess(respData.user.company);

        setUserVerified(true);
      } else {
        navigate("/");
      }
    } catch (error) {
      navigate("/");
    }
  };

  useEffect(() => {
    verifyUser();
  }, []);

  return (
    <div>
      {userVerified ? (
        <Routes>
          <Route
            path="/"
            element={
              <Dashboard
                role={role}
                dataAccessDays={dataAccessDays}
                companyAccess={companyAccess}
                link={link}
              />
            }
          />
        </Routes>
      ) : (
        <div className="full-page-fixed-component">Verifying......</div>
      )}
    </div>
  );
};

export default UserRoute;
